exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create_pdf{background-color:#4caf50;border:none;color:#fff;padding:10px 32px;text-align:center;text-decoration:none;display:inline-block;font-size:16px;margin-left:50%;margin-right:50%}", ""]);

// exports
